import api from "../atlasApi";


export const serviceGenerateArc = (data) => {
  return api.post("/horizon/generate-arc/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};
